import { useMemo } from 'react';
import { useSearchParams } from 'react-router';
import { type VehicleListColumnKey } from '../VehicleList';

function useSortColumn(defaultValue: VehicleListColumnKey | null): VehicleListColumnKey | null {
  const [searchParameters] = useSearchParams();

  return useMemo(() => {
    const value = searchParameters.get('sortColumn') as VehicleListColumnKey | null;
    if (searchParameters.get('sortColumn') === 'gtwMedianTonnes') return 'gtwQ3Tonnes';
    if (searchParameters.get('sortColumn') === 'operationalIntensity') return 'stateOfHealth';
    return value ?? defaultValue;
  }, [searchParameters, defaultValue]);
}

export default useSortColumn;
